module.exports = __webpack_public_path__ + "static/media/boat-img-39.cf154d7a.jpg";